// extracted by mini-css-extract-plugin
export default {"search":"History_search__bBu5f","load_more":"History_load_more__na7Up"};